<template>
  <v-dialog
    :model-value="modelValue"
    fullscreen
    scrim="black"
    content-class="image-fullscreen-overlay"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div class="image-fullscreen-content">
      <button
        class="image-fullscreen-close"
        aria-label="Fechar"
        data-testid="fullscreen-close-button"
        @click="emit('update:modelValue', false)"
      >
        <v-icon size="28" color="#16161d">{{ mdiClose }}</v-icon>
      </button>

      <div class="image-fullscreen-actions">
        <button
          class="image-fullscreen-action"
          data-testid="fullscreen-rotate-button"
          @click="handleRotate"
        >
          <v-icon size="20" color="#52526f">{{ mdiRotateRight }}</v-icon>
        </button>
      </div>

      <ProtectedImage
        :biometry-id="biometryId"
        :blob-url="blobUrl"
        :rotation="rotation"
        img-class="image-fullscreen-img"
        container-class="image-fullscreen-protected"
        data-testid="fullscreen-image"
      />
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { mdiClose, mdiRotateRight } from '@mdi/js'
import ProtectedImage from './ProtectedImage.vue'

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    biometryId?: number
    blobUrl?: string
    rotation?: number
  }>(),
  { rotation: 0 }
)

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'update:rotation': [value: number]
}>()

function handleRotate() {
  emit('update:rotation', (props.rotation + 90) % 360)
}
</script>

<style>
.image-fullscreen-overlay {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100vw !important;
  height: 100vh !important;
  max-height: 100vh !important;
  background: rgba(0, 0, 0, 0.9) !important;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
}

.image-fullscreen-content {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.image-fullscreen-protected {
  width: auto !important;
  height: auto !important;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-fullscreen-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  user-select: none;
  transition: transform 0.2s ease;
}

.image-fullscreen-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  padding: 8px;
  border-radius: 9999px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  border: none;
  transition: background 0.2s;
}

.image-fullscreen-close:hover {
  background: #e5e7eb;
}

.image-fullscreen-actions {
  position: absolute;
  top: 76px;
  right: 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.image-fullscreen-action {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  border: none;
  transition: background 0.2s;
}

.image-fullscreen-action:hover {
  background: #e5e7eb;
}
</style>
